// Fixed backend-local codes are an allowlist for telemetry, not response payloads.
// Sources: modules/**/*.errors.ts and literal errorCode responses. New codes must
// be verified here before telemetry can collect them; never accept arbitrary text.
export const LEGACY_API_ERROR_CODES = [
  'ADCODE_ARCHIVE_REQUIRES_STOP',
  'ADCODE_CONFLICT',
  'ADCODE_INVALID_TRANSITION',
  'ADCODE_NOT_FOUND',
  'ADCODE_ROSTER_ENTRY_NOT_FOUND',
  'ADCODE_ROSTER_ENTRY_UNRESOLVED',
  'ADCODE_ROSTER_ENTRY_VIDEO_MISSING',
  'ADCODE_UNKNOWN_STAGE',
  'ADVERTISER_MERGED',
  'ADVERTISER_NOT_FOUND',
  'BRAND_ADVERTISER_MISMATCH',
  'BRAND_NAME_DUPLICATE',
  'CAMPAIGN_MANAGER_BONUS_ALREADY_SETTLED',
  'CAMPAIGN_MANAGER_BONUS_LEDGER_MISSING',
  'CAMPAIGN_TIMELINE_INVALID',
  'CAMPAIGN_TIMELINE_REASON_REQUIRED',
  'CAMPAIGN_TIMELINE_STALE',
  'CLOSE_FAILED',
  'CREATOR_MAIL_CONNECTION_BROKEN',
  'CREATOR_MAIL_DRAFT_OWNED',
  'CREATOR_MAIL_NOT_CONNECTED',
  'CREATOR_MAIL_NO_CREATOR_EMAIL',
  'CREATOR_MAIL_OAUTH_NOT_CONFIGURED',
  'CREATOR_MAIL_SEND_PENDING',
  'CREATOR_MAIL_SEND_UNCONFIRMED',
  'CREATOR_MAIL_THREAD_CHANGED',
  'CREATOR_MAIL_THREAD_FORBIDDEN',
  'CREATOR_PII_ENCRYPTION_UNAVAILABLE',
  'CREATOR_RELATION_NOT_FOUND',
  'DOCUMENT_CHANGED',
  'DOCUMENT_NOT_AVAILABLE',
  'GOOGLE_FORM_WATCH_DELETE_PENDING',
  'HISTORICAL_BATCH_NOT_FOUND',
  'HISTORICAL_SCENARIO_UNAVAILABLE',
  'HISTORICAL_SELECTION_INVALID',
  'HISTORICAL_SOURCE_ALREADY_DECIDED',
  'HISTORICAL_SOURCE_ALREADY_REGISTERED',
  'HISTORICAL_SOURCE_BODY_INVALID',
  'HISTORICAL_SOURCE_CHANGED',
  'HISTORICAL_SOURCE_NOT_APPROVED',
  'HISTORICAL_SOURCE_REGISTRATION_NOT_FOUND',
  'HISTORICAL_SOURCE_SCENARIO_ALREADY_APPLIED',
  'HISTORICAL_SOURCE_SELF_DECISION',
  'INVALID_TARGET_SLOT_CURSOR',
  'INVALID_TARGET_SLOT_REQUEST',
  'INVALID_TEAM_IDS',
  'KAKAO_CHANNEL_NAME_FORBIDDEN',
  'KNOWLEDGE_CONNECTION_NOT_CONFIGURED',
  'KNOWLEDGE_DECISION_CHANGED',
  'KNOWLEDGE_ENCRYPTION_UNAVAILABLE',
  'KNOWLEDGE_GOOGLE_CONNECTION_REQUIRED',
  'KNOWLEDGE_REPLACEMENT_PENDING',
  'MAIL_TOKEN_ENCRYPTION_UNAVAILABLE',
  'NUMERIC_ID_NOT_COLLECTED',
  'OUTREACH_REINCLUDE_CHANGED',
  'OUTREACH_REINCLUDE_NOT_EXCLUDED',
  'REPLACES_TARGET_INVALID',
  'ROSTER_ADVERTISER_APPROVAL_NEEDS_SELECT',
  'ROSTER_ADVERTISER_APPROVAL_REQUIRED',
  'ROSTER_ADVERTISER_REJECT_NEEDS_ROUND',
  'ROSTER_ADVERTISER_REPORT_NEEDS_ROUND_FREE',
  'ROSTER_ADVERTISER_REVIEW_MODE_CONFLICT',
  'ROSTER_ADVERTISER_REVIEW_MODE_UNCHANGED',
  'ROSTER_ADVERTISER_SELECT_OFF',
  'ROSTER_ADVERTISER_SKIP_NEEDS_REASON',
  'ROSTER_ALREADY_DROPPED',
  'ROSTER_ALREADY_LOCKED',
  'ROSTER_ALREADY_RESOLVED',
  'ROSTER_ASSIGNEE_NOT_IN_SCENARIO_TEAMS',
  'ROSTER_ASSIGNEE_REASSIGN_FORBIDDEN',
  'ROSTER_CAMPAIGN_TYPE_FIELD',
  'ROSTER_CELL_CONFLICT',
  'ROSTER_COLLECTION_CHANGED',
  'ROSTER_CONTRACT_VIDEO_SOURCE_DROPPED',
  'ROSTER_CREATOR_ABSENCE_UNVERIFIED',
  'ROSTER_CREATOR_RECRUITMENT_INELIGIBLE',
  'ROSTER_CREATOR_TOMBSTONED',
  'ROSTER_CREDITED_NOT_IN_SCENARIO_TEAMS',
  'ROSTER_DRAFT_ARRIVAL_ALREADY_MARKED',
  'ROSTER_DRAFT_ARRIVAL_NOT_APPLICABLE',
  'ROSTER_DROP_RESTORE_FORBIDDEN',
  'ROSTER_EXPORT_FORBIDDEN',
  'ROSTER_EXTRA_POST_ALREADY_TAKEN_DOWN',
  'ROSTER_EXTRA_POST_DUPLICATE',
  'ROSTER_EXTRA_POST_MALFORMED_URL',
  'ROSTER_EXTRA_POST_NOT_FOUND',
  'ROSTER_EXTRA_POST_SAME_AS_PRIMARY',
  'ROSTER_HANDLE_AMBIGUOUS',
  'ROSTER_HANDLE_NOT_FOUND',
  'ROSTER_IMPORT_DUPLICATE_ROWS',
  'ROSTER_IMPORT_FORBIDDEN',
  'ROSTER_INTERNAL_PROPOSAL_LOCKED',
  'ROSTER_INVALID_ADVERTISER_REVIEW_MODE',
  'ROSTER_INVALID_CONTENT_REVIEW',
  'ROSTER_INVALID_CURRENCY',
  'ROSTER_INVALID_DROP_KIND',
  'ROSTER_INVALID_REVIEW_VERDICT',
  'ROSTER_INVALID_STATUS',
  'ROSTER_INVALID_TAKEDOWN_REQUESTER',
  'ROSTER_LIFECYCLE_CHANGED',
  'ROSTER_NOT_DROPPED',
  'ROSTER_NOT_EXPORT_EXCLUDED',
  'ROSTER_NOT_FOUND',
  'ROSTER_NOT_LOCKED',
  'ROSTER_NOT_RESOLVED',
  'ROSTER_NOT_UNREGISTERED',
  'ROSTER_NOT_UPLOAD_COMPLETE',
  'ROSTER_NO_DRAFT_ARRIVAL_TO_REVOKE',
  'ROSTER_NO_NUDGE_TO_REVOKE',
  'ROSTER_NUDGE_NOT_APPLICABLE',
  'ROSTER_PAYOUT_ALREADY_REGISTERED',
  'ROSTER_PAYOUT_CREATOR_MISSING',
  'ROSTER_PAYOUT_FORBIDDEN',
  'ROSTER_RELINK_LOCKED',
  'ROSTER_RELINK_SAME_CREATOR',
  'ROSTER_REVIEW_FORBIDDEN',
  'ROSTER_REVIEW_ROUND_CLOSED',
  'ROSTER_REVIEW_ROUND_CONDITIONS_MISSING',
  'ROSTER_REVIEW_ROUND_ROW_DECIDED',
  'ROSTER_REVIEW_ROUND_ROW_INELIGIBLE',
  'ROSTER_REVIEW_ROUND_ROW_NOT_IN_ROUND',
  'ROSTER_REVISION_REREQUEST_NOT_APPLICABLE',
  'ROSTER_SCENARIO_CLOSED',
  'ROSTER_SCHEDULE_DATE_REQUIRED',
  'ROSTER_SHIPPING_ADDRESS_FORBIDDEN',
  'ROSTER_SHIPPING_ADDRESS_MISSING',
  'ROSTER_SHIPPING_NOT_APPLICABLE',
  'ROSTER_SOURCE_UNAVAILABLE',
  'ROSTER_TAKEDOWN_REQUIRED',
  'ROSTER_UNASSIGNED_HANDLE_CONFLICT',
  'ROSTER_UNREGISTERED_HAS_CANDIDATE',
  'ROSTER_VIDEO_CONFLICT',
  'SCENARIO_CAMPAIGN_SHEET_URL_INVALID',
  'SCENARIO_NOT_FOUND',
  'SCENARIO_OUTREACH_FORM_ALREADY_EXISTS',
  'SCENARIO_OUTREACH_FORM_MISSING',
  'SCENARIO_OUTREACH_FORM_PROVISION_FAILED',
  'SCENARIO_OUTREACH_FORM_TEMPLATE_MISSING',
  'SCENARIO_OUTREACH_FORM_URL_INVALID',
  'SETTLEMENT_APPROVAL_CLEARANCE_REASON_REQUIRED',
  'SETTLEMENT_CURRENCY_NOT_ALLOWED',
  'SETTLEMENT_ENTRY_NOT_FOUND',
  'SETTLEMENT_IDEMPOTENCY_CONFLICT',
  'SETTLEMENT_INVALID_TRANSITION',
  'SETTLEMENT_ROSTER_ENTRY_NOT_IN_SCENARIO',
  'SETTLEMENT_ROSTER_ENTRY_UNRESOLVED',
  'SETTLEMENT_SCENARIO_NOT_FOUND',
  'SETTLEMENT_STATUS_CONFLICT',
  'SETTLEMENT_TERM_NOT_ALLOWED_FOR_CAMPAIGN',
  'SETTLEMENT_UNKNOWN_STATUS',
  'TARGET_SLOT_CANDIDATES_PAGINATION_REQUIRED',
  'VIDEO_RETENTION_STALE',
  'VIDEO_TRACKING_ALREADY_REGISTERED',
  'VIDEO_TRACKING_CHECK_ID_PAYLOAD_MISMATCH',
  'VIDEO_TRACKING_DUPLICATE_VIDEO',
  'VIDEO_TRACKING_INVALID_EVENT',
  'VIDEO_TRACKING_INVALID_JSON',
  'VIDEO_TRACKING_INVALID_LINK',
  'VIDEO_TRACKING_INVALID_MAPPING',
  'VIDEO_TRACKING_INVALID_TRANSITION',
  'VIDEO_TRACKING_LEADER_ONLY',
  'VIDEO_TRACKING_MAPPING_CONFLICT',
  'VIDEO_TRACKING_NOT_CORRECTABLE',
  'VIDEO_TRACKING_NOT_FAILED',
  'VIDEO_TRACKING_NOT_FOUND',
  'VIDEO_TRACKING_NOT_REPLACEABLE',
  'VIDEO_TRACKING_RECEIVE_FAILED',
  'VIDEO_TRACKING_REPLACEMENT_NEEDS_CONFIRM',
  'VIDEO_TRACKING_REPLACEMENT_PENDING',
  'VIDEO_TRACKING_REQUEST_ID_REUSED',
  'VIDEO_TRACKING_REUPLOAD_NOT_REQUESTED',
  'VIDEO_TRACKING_ROSTER_MISMATCH',
  'VIDEO_TRACKING_SAME_LINK',
  'VIDEO_TRACKING_SLOT_MISMATCH',
  'VIDEO_TRACKING_STALE_CONTROL',
  'VIDEO_TRACKING_STORAGE_UNAVAILABLE',
  'VIDEO_TRACKING_UNKNOWN_TRACKING',
  'VIDEO_TRACKING_VIDEO_MISMATCH',
] as const;
